import { render, staticRenderFns } from "./OtherAssessments.vue?vue&type=template&id=a5f72f78"
import script from "./OtherAssessments.vue?vue&type=script&lang=js"
export * from "./OtherAssessments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports